// src/services/account.js

import axiosServices from "./axios";

export const changePassword = async (oldPassword, newPassword) => {
  return axiosServices.post(`/user/change-pwd`, {
    password: oldPassword,
    newPassword,
  });
};

// --- START: NEW AND MODIFIED FUNCTIONS ---

// New function to request the OTP
export const sendDeleteOtp = async () => {
  return axiosServices.post(`/user/send-delete-otp`);
};

// Modified function to include the OTP in the delete request
export const deleteAccount = async (otp) => {
  return axiosServices.post(`/user/delete`, { otp });
};

// --- END: NEW AND MODIFIED FUNCTIONS ---